<template>
  <div>
    <div class="advertising-space-container">
      <div v-if="commoditiesShow" class="commodities-container">
        <div v-if="limitedTimeOffer" class="limited-time-offer-container">
          <span class="description">
            <svg-icon name="ic-sales" class="sales-icon" />
            <span class="text">Limited Time Offer</span> {{ commoditiesInfo.dayCount }} Days left
          </span>
          <span v-if="commoditiesInfo.discountRate" class="first-month">
            First Month
            <span class="text">
              <i>{{ commoditiesInfo.discountRate }}% Off</i>
            </span>
            For New Users
          </span>
          <span class="jump-subscribe" @click="jumpSubscribe">Start Free Trial</span>
        </div>
        <div v-else-if="limitedTimeOfferExpires" class="limited-time-offer-expires-container">
          <span class="text">Upgrade your plan to unlock all of COMMAND's powerful features!</span>
          <span class="jump-subscribe" @click="jumpSubscribe">Start Free Trial</span>
        </div>
        <div v-else-if="trialEnd" class="trial-end-container">
          <span class="text">Upgrade your plan to unlock all of COMMAND's powerful features!</span>
          <span class="jump-subscribe" @click="jumpSubscribe">Upgrade now</span>
        </div>
      </div>
    </div>
    <div :style="{ 'background-color': backgroundColor }" class="header-top-bar">
      <div class="header-left">
        <div v-if="warningText" class="warning">{{warningText}}</div>
      </div>
      <div class="header-bar" v-if="userId">
        <ul class="header-top-ul">
          <li>
            <el-popover
              @show="hideUser"
              trigger="hover"
              :disabled="isDisabled"
              width="170"
              :open-delay="0"
              :close-delay="0"
              v-model="addBtn"
              popper-class="header-top-pop header-top-pop-transform-y"
              placement="bottom">
              <div :class="['header-top-add', 'header-dialog-fill']">
                <div @click="addItem('driver')" v-if="usersAuthorities['fleet:accountOperation:driverCreate'] === 'true'"><svg-icon name="new-icons-16-line-driver" style="color:#000"></svg-icon>Add New Drivers</div>
                <el-tooltip class="item" effect="dark" content="No Permission" placement="left" v-else>
                  <div style="color:#b2b6c0"><svg-icon style="color:#b2b6c0" name="new-icons-16-line-driver"></svg-icon>Add New Drivers</div>
                </el-tooltip>

                <div @click="addItem('load')"><svg-icon name="new-icons-16-line-loads" ></svg-icon>Add New Loads</div>
                <div @click="addItem('truck')"><svg-icon name="new-icons-16-line-truck" ></svg-icon>Add New Trucks</div>
              </div>
              <!-- <div slot="reference" :class="['header-top-add-btn', 'header-top-btn', addBtn ? 'is-active' : '']"></div> -->
              <common-button
                v-if="!(systemSource === 'dispatcher' && usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false')"
                slot="reference"
                :icon="!addBtn ? 'icon-top-add-hover' : 'icon-top-add'"
                type="text"
                size="small"
                :color="!addBtn? '#4c556c' : '#4066d4'"
                :class="[ addBtn ? 'headr-top-add' : '', 'header-top-add-font']"
                >Add New</common-button>
            </el-popover>
          </li>
          <li>
            <div class="dialer-con" ref="dialerPadBtn" >
              <div class="dialer-unread" ref="unreadNum" @click="openDialerPad"></div>
              <div class="header-top-dialer-btn header-top-btn" @click="openDialerPad">
                <svg-icon name="call" style="width:24px; height: 24px;"/>
              </div>
            </div>
          </li>
          <li>
            <el-popover
              trigger="hover"
              @show="hideUser"
              width="206"
              :disabled="isDisabled"
              :open-delay="0"
              :close-delay="0"
              v-model="setBtn"
              popper-class="header-top-pop header-top-pop-transform"
              placement="bottom">
              <div :class="['header-top-add', 'header-dialog-fill']">
                <template>
                  <div
                    @click="goLink(item)"
                    v-for="(item, index) in settingList"
                    :key="index">
                      <svg-icon :name="item.meta.icon"></svg-icon>
                      {{item.meta.title}}
                  </div>
                  <div 
                    @click="goInsurance()">
                    <svg-icon name="insurance"></svg-icon>
                      Insurance
                    <svg-icon name="new-tag" v-if="showInsuranceNewTag" style="width: 34px; height: 16px; margin-left: 4px"></svg-icon>
                    </div>
                    <div @click="goFuelCard()">
                      <svg-icon name="fuelCard"></svg-icon>
                      Fuel Card
                    <svg-icon name="new-tag" v-if="showFuelCardNewTag" style="width: 34px; height: 16px; margin-left: 4px"></svg-icon>
                  </div>
                  <div
                      @click="goDialerSettings()">
                    <svg-icon name="phone-outlined"></svg-icon>
                    Dialer Settings
                  </div>
                  <div
                    v-if="$checkPermission(['admin'])"
                    @click="goPermissionSettings()">
                      <svg-icon name="permissionSettings"></svg-icon>
                      Permission Settings
                  </div>
                  <div @click="goOnboarding()" v-if="userInfo && userInfo.onboardingShow && userInfo.onboardingShow === 1 ">
                      <svg-icon name="onboarding"></svg-icon>
                      Onboarding
                    <svg-icon name="new-tag" v-if="showOnboardingNewTag" style="width: 34px; height: 16px; margin-left: 4px"></svg-icon>
                  </div>
                </template>
              </div>
              <div slot="reference" id='tp-setting' :class="['header-top-setting-btn', 'header-top-btn',  setBtn ? 'is-active' : '']"></div>
            </el-popover>
          </li>
          <li>
            <el-popover
              trigger="hover"
              @show="hideUser"
              width="252"
              :disabled="isDisabled"
              :open-delay="0"
              :close-delay="0"
              v-model="helpBtn"
              popper-class="header-top-pop header-top-pop-help"
              placement="bottom">
              <div :class="['header-top-help', 'header-dialog-fill']">Send a message to Command customer service</div>
              <div slot="reference" :class="['header-top-support', 'header-top-btn',  helpBtn ? 'is-active' : '']" @click="support"></div>
            </el-popover>
          </li>
          <li>
            <div class="header-top-user-info">
                <fl-avatar @click.stop.native="userPop = !userPop" class="avatar" :size="26"/>
                <div>
                  <el-popover
                    trigger="hover"
                    width="90"
                    :disabled="userPop"
                    :open-delay="0"
                    :close-delay="0"
                    v-model="profile"
                    popper-class="header-top-pop header-top-pop-help header-top-profile"
                    placement="bottom">
                    <div :class="['header-top-help', 'header-dialog-fill']">
                      <div>Your profile</div>
                    </div>
                    <div @click.stop="userPop = !userPop" slot="reference" :class="['header-top-user-name', userPop || profile ? 'header-user-name' : '']" >{{firstName}} {{lastName}}</div>
                  </el-popover>
                </div>
              <div>
                  <el-popover
                    trigger="click"
                    width="270"
                    :open-delay="0"
                    :close-delay="0"
                    :offset="202"
                    @show="profile = false"
                    v-model="userPop"
                    popper-class="header-top-pop header-top-user"
                    placement="bottom">
                    <div class="header-user-box">
                      <div class="flex header-user-info">
                        <fl-avatar  :size="32"/>
                        <div class="flex header-user--info-list">
                          <p>
                            <!-- {{firstName}} {{lastName}} -->
                            <common-ellipsis-tooltip
                              effect="dark"
                              :content="fullName"
                              placement="top"
                            ></common-ellipsis-tooltip>
                          </p>
                          <p>
                            <!-- {{email}} -->
                            <common-ellipsis-tooltip
                              effect="dark"
                              :content="email"
                              placement="top"
                            ></common-ellipsis-tooltip>
                          </p>
                          <p>
                            <!-- {{companyName}} -->
                            <common-ellipsis-tooltip
                              effect="dark"
                              :content="companyName"
                              placement="top"
                            ></common-ellipsis-tooltip>
                          </p>
                        </div>
                      </div>
                      <div class="header-user-opt header-user-opt-status" ref="userDialerStatus">
                      </div>
                      <div class="header-user-opt" @click="editProfile"><svg-icon name="icons-24-line-edit" ></svg-icon>Edit Profile</div>
                      <div class="header-user-opt" @click="logout"><svg-icon name="icons-24-line-log-out"></svg-icon>Log out</div>
                    </div>
                    <div slot="reference" :class="['header-top-down-btn', profile ? 'header-top-down-btn-hover' : '', userPop ? 'header-top-up' : '']"></div>
                  </el-popover>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="header-login" v-else>
        <span @click="logInPage({isLogin: true})">Log In</span>
        <common-button type='primary' size="mini"  @click="signUp"> SIGN UP</common-button>
      </div>
      <ShareTripHelp v-if="isShowShareTripDetail" :style="{ height: topHeight > 94 ? topHeight + 'px' : 94 + 'px' }" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { sidebarDisabled } from '@/store/modules/permission-v2'
import store from '@/store'
import appendToDom from "@/components-v3/mixins/append-to-dom"
import {getStorage} from "@/utils/storage";
import {updateFuelCardGuide, updateInsuranceGuide, updateDialerGuide, getCommodities} from "@/api/user";
import {dispatchCommandLike$, registerGuid$, DispatchComponents$ } from "@/shared-services";
import { guidePopover } from '@/utils/popver'
import { getService$ } from '@/shared-services.js'
import commonPopover from '@/components-v2/common-popover'
import ShareTripHelp from '@/views/share-trip-help'
import matchWhitelist from "@/router-v2/whitelist";
import router from '@/router-v2';
import { updateGuide } from '@/api/onboarding';

export default {
  name: 'headerBar',
  mixins: [appendToDom(document.getElementById('top-bar'))],
  components: { ShareTripHelp },
  data() {
    return {
      statusLoading: false,
      isNotDisturb: false,
      warningText: '',
      addBtn: false,
      setBtn: false,
      dialerBtn: false,
      helpBtn: false,
      profile: false,
      userPop: false,
      showInsuranceNewTag: false,
      showFuelCardNewTag: true,
      showOnboardingNewTag: true,
      settingList: [],
      backgroundColor: '#f5f6f8',
      isDisabled: false,
      commoditiesInfo: null,
      currentPath: '',
      pathList: [/^\/subscription\/command-seats(\/.*)?$/, /^\/setting\/subscription-and-billing-v2\/manage(\/.*)?$/],
      // sidebarDisabled: sidebarDisabled(store)
    }
  },
  watch: {
    "$route": {
      handler(newVal) {
        this.currentPath = newVal.path
        if (/^\/map(\/.*)?$/.test(newVal.path)||newVal.path=='/dashboardv2') {
          this.backgroundColor = '#ffffff'
        } else {
          this.backgroundColor = '#f5f6f8'
        }
      },
      immediate: true
    },
    dialerSubscriptionCount: {
      handler(value) {
        this.guidePlan(value)
      },
      deep: true,
    },
    commoditiesShow: {
      handler(value) {
        if (value) {
          this.updateTopHeight(84)
        } else {
          this.updateTopHeight(40)
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user,
      dialerSubscriptionCount: state => state.user.subscriptionCount.dialerSubscriptionCount,
      routes: state => state.permissionV2.routes,
      demoType: state => state.user.demoType,
      firstName: state => state.user.firstName,
      lastName: state => state.user.lastName,
      email: state => state.user.email,
      companyName: state => state.user.companyName,
      expiredDemoAccount: state => state.user.expiredDemoAccount,
      usersAuthorities: state => state.user.usersAuthorities,
      fuelCardGuide: state => state.user.fuelCardGuide,
      hasBaseDialerSeat: state => state.user.hasBaseDialerSeat,
      showRouteDetail: state => state.tripPlan.showRouteDetail,
      routeDetailTab: state => state.tripPlan.routeDetailTab,
      insuranceGuide: state => state.user.insuranceGuide,
      onboardingGuide: state => state.user.onboardingGuide
    }),
    ...mapGetters("user", ["usersAuthorities", "systemSource", 'userId', 'registeredTrial', 'topHeight']),
    fullName() {
      return this.firstName + ' ' + this.lastName
    },
    isShowShareTripDetail() {
      let path = this.$route.path
      let status = this.showRouteDetail && this.routeDetailTab === 'shareTripDetail' && !this.userId && path === '/map/index'
      if (status) {
        this.updateHelpHeight(this.topHeight > 94 ? 0 : 94 - this.topHeight)
      } else {
        this.updateHelpHeight(0)
      }
      return status
    },
    commoditiesShow() {
      return (
        this.pathList.every(item => !item.test(this.currentPath))
        && this.demoType === 'freemium'
        && (this.limitedTimeOffer || this.limitedTimeOfferExpires || this.trialEnd)
      )

    },
    limitedTimeOffer() {
      try {
        return this.commoditiesInfo.dayCount > 0 && this.commoditiesInfo.dayCount <= 14 && !this.registeredTrial
      } catch {
        return false
      }
    },
    limitedTimeOfferExpires() {
      try {
        return !this.commoditiesInfo.dayCount && !this.registeredTrial
      } catch {
        return false
      }
    },
    trialEnd() {
      try {
        return this.registeredTrial
      } catch {
        return false
      }
    }
  },
  created() {
    if (getStorage('x-portal-token') === 'yes') {
      this.warningText = 'ATTENTION: you are now logged into a customer\'s account, everything you change will be applied to this account. Please double check before making any changes!!'
    } else {
      this.getCommodities()
    }
  },
  methods: {
    ...mapActions({
      logout: 'user/logout',
      updateHelpHeight: 'user/updateHelpHeight',
      updateTopHeight: 'user/updateTopHeight',
      getUser: 'user/getUser'
    }),
    ...mapActions('basicInfo', [
      'setPageName'
    ]),
    signUp() {
      this.$buriedPoints(2.2)
      this.$emit('openRegist')
    },
    createPopoverDom(data) {
      guidePopover(commonPopover, data)
    },
    openDialerPad() {
      this.$buriedPoints(19.00);
      dispatchCommandLike$.subscribe(x => x.openDialerPad())
    },
    support() {
      if (this.isDisabled) {
        return
      }
      this.$zendeskShow()
    },
    hideUser() {
      this.userPop = false
    },
    logInPage({isLogin}) {
      this.$root.$emit("globalMarketingTools", {
        isLogin: isLogin,
        marketingUtm: {
              utm_source: 'Freemium',
              utm_content: 'Map popup'
        },
        })
    },
    clickBar(data) {
      this.clickId = data
    },
    goLink(data) {
      switch(data.name){
        case 'Subscription and Billing':
              this.$buriedPoints(19.04)
              break;
      }
      if(data.disabled) {
        return
      }
      this.$router.push({
        name: data.name
      })
    },
    goDialerSettings() {
      this.$buriedPoints(19.01);
      this.$router.push({
        path: "/dialerSetting"
      })
    },
    goInsurance() {
      this.showInsuranceNewTag = false;
      this.updateInsuranceGuideF();
      this.$router.push({
        path: "/insurance"
      })
    },
    updateInsuranceGuideF() {
      updateInsuranceGuide().then(
        (result) => {
          if (result.code == 200) {
            console.log(result)
          } else {
            this.$message.error({ message: result.message });
          }
        },
        (error) => {
          this.$message.error({ message: error.error.message });
        }
      );
    },
    goPermissionSettings() {
      if (this.demoType !== 'freemium') {
        this.$router.push({
          path: "/permissionSettings"
        })
      } else {
        this.$router.push({
          path: '/intercept/permissionSettings'
        })
      }
    },
    goOnboarding(){
      this.showOnboardingNewTag = false;
      if(!this.showOnboardingNewTag){
        updateGuide({guide: "onboardingGuide"})
      }
      this.$router.push({
        path: '/onboarding/index'
      })
    },
    goFuelCard() {
      this.showFuelCardNewTag = false;
      this.updateFuelCardGuideF();
      this.$router.push({
          path: '/fuel-card'
        })
    },
    updateFuelCardGuideF() {
      updateFuelCardGuide().then(
        (result) => {
          if (result.code == 200) {
            console.log(result)
          } else {
            this.$message.error({ message: result.message });
          }
        },
        (error) => {
          this.$message.error({ message: error.error.message });
        }
      );
    },
    editProfile() {
      if(sidebarDisabled(store.state)) {
        return
      }
      this.userPop = false
      this.setPageName()
      if (this.$route.name !== 'basicInfo') {
        this.$router.push({
          name: "basicInfo",
          query: {
            pageName: "Profile",
          },
        });
      }

    },
    addItem(data) {
      if(sidebarDisabled(store.state)) {
        return
      }
      switch(data) {
        case 'driver':
          this.$router.push({
            path: "driverAdd",
            name: "driverAdd",
            query: {
              type: "add",
              sourceType: "Topbar",
            },
          });
          break
        case 'load':
          this.$router.push({
            name: "dispatchLoadAdd",
            query: {
              type: "add",
              only: 1,
              sourceType: 'Topbar',
            },
          });
          break
        case 'truck':
          this.$router.push({
            path: "/assets/create/truck",
            // name: "trucksAdd",
            query: {
              type: "add",
              typeFrom: "Truck",
            },
          });
          break
      }
    },
    guidePlan(key) {
      switch (key) {
        case 1:
          this.$nextTick(() => {
          const billing_el = document.querySelector('#tp-setting')
          const {top, left} = billing_el.getBoundingClientRect()
          const content = 'Learn more about subscription options here. After subscribing, make sure you assign the seat of the subscription.'
          const title = 'Subscription and Billing'
          this.createPopoverDom({top: top+40, left: left-150, content, count: 1, dialerSubscriptionCountKey: 'dialerSubscriptionCount', title, isActive: true})
        })
          break;
        case 2:
          this.$nextTick(() => {
          const content = 'Team members must be assigned a virtual mobile phone number before they can use the browser to make calls.'
          const subscription_el = document.querySelector('#tp-setting')
          const {top, left} = subscription_el.getBoundingClientRect()
          const title = 'Dialer Settings'
          this.createPopoverDom({top: top+40, left: left-150, content, count: 2, dialerSubscriptionCountKey: 'dialerSubscriptionCount', title, isActive: true})
        })
          break;
        case 3:
          this.$nextTick(() => {
          const content = 'Here you can make calls, view recent call history, listen to voicemails and more.'
          const subscription_el = document.querySelector('#tp-setting')
          const {top, left} = subscription_el.getBoundingClientRect()
          const title = 'Start a call here'
          this.createPopoverDom({top: top+40, left: left-183, content, count: 3, dialerSubscriptionCountKey: 'dialerSubscriptionCount', title, isActive: true, confirmText: 'Got It'})
        })
          break;
        default:
          break;
      }
    },
    initGuidePlan() {
      const isHasGuideKey = sessionStorage.getItem('dialerSubscriptionCount')
      getService$('CommandTools').subscribe(x => {
        x.$dspClickEvent.subscribe({
          next: (x) => {
            if(x && !isHasGuideKey && isHasGuideKey !== 'dialerSubscriptionCount' && this.userInfo.dialerSubscriptionGuide) {
              this.guidePlan(1)
              updateDialerGuide()
            }
          }
        })
      })
    },
    getCommodities() {
      getCommodities().then(res => {
        try {
          this.commoditiesInfo = res.data || {}
        } catch {
          this.commoditiesInfo = {}
        }
      })
    },
    jumpSubscribe() {
      this.$router.push('/setting/subscription-and-billing-v2/manage')
    }
  },
  mounted() {
    console.log(6000000000, this.userInfo);
    const list = this.routes.find(res => res.name === 'Setting')
    if (list && list.children) {
      this.settingList = list.children.filter(res => !res.hidden)
    }
    this.isDisabled = sidebarDisabled(store.state)
    this.showInsuranceNewTag = this.insuranceGuide;
    console.log(this.$route)
    this.showFuelCardNewTag = this.fuelCardGuide;
    this.showOnboardingNewTag = this.onboardingGuide;
    if(!this.hasBaseDialerSeat){
      registerGuid$.subscribe(x => x({
      name: 'topBarDialerBtn',
      target: this.$refs.dialerPadBtn
     }))
    }
    DispatchComponents$.subscribe(x => {
      x.DialerUnreadCount(this.$refs.unreadNum);
      x.UserDialerStatus(this.$refs.userDialerStatus)
    })
    this.initGuidePlan()

    this.$nextTick(() => {
      const needLogin = [/^\/map\/index(\/.*)?$/,  /^\/intercept(\/.*)?$/]
      if(matchWhitelist(router.currentRoute.path) && !needLogin.some(item => item.test(router.currentRoute.path))) return;
      !getStorage() && this.logInPage({isLogin: location.search.includes("isLogin=true")})
    })
  },
}
</script>
<style lang="scss" scoped>
  .flex{
    display: flex;
  }
  .dialer-con{
    position: relative;
    width:24px;
    height:24px;
    border-radius: 4px;
    cursor: pointer;
    &:hover{
      background: #E9EAED;
    }
    .dialer-unread{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top:0;
    min-width: 16px;
    height: 16px;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #fff;
    border-radius: 8px;;
  }
  }

  .header-top-bar{
    height: 40px;
    width: 100%;
    background: #f5f6f8;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 24px;
    box-shadow: inset 0 -1px 0 0 rgba(218, 220, 225, 0.5);
    .header-top-ul{
      display: flex;
      align-items: center;
      li{
        height: 24px;
        margin-left: 16px;
        &:last-child{
          height: 26px;
          margin-left: 24px;
        }
        &:first-child{
          height: 24px;
        }
      }
    }
  }
  .header-left {
    flex: 1;
    .warning {
      color: red;
      text-align: center;
      font-weight: bolder;
      font-size: 15px;
    }
  }
  .insurance {
    display: flex;
    flex-direction: row;
    gap: 4px;
  }
  .new {
    width: 35px !important;
    height: 16px !important;

    background: #6A8AE8;
    border-radius: 10px !important;
    text-align: center !important;
    padding: 6px !important;

    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 10px !important;
    line-height: 14px !important;


    color: #FAFBFC !important;
    &:hover{
      background: #6A8AE8 !important;
    }
    
  }

  

  .header-top-add-btn{
    background: url('~@/assets/img/tp-header/icons-16-line-add.svg') no-repeat;
    &.is-active{
      background-image: url('~@/assets/img/tp-header/icons-16-line-add-active.svg');
    }
  }

  .header-top-support{
    background: url('~@/assets/img/tp-header/icons-24-support.svg') no-repeat;
  }
  .header-top-dialer-btn{
    color: #4C556C;
    &:hover{
      color: #4066D4;
    }
  }
  .header-top-setting-btn{
    background: url('~@/assets/img/tp-header/icons-24-setting.svg') no-repeat;
     &.is-active{
      background-image: url('~@/assets/img/tp-header/icons-24-setting-active.svg');
    }
  }
  .header-top-down-btn{
    margin-top: 5px;
    width: 16px;
    height: 16px;
    background-position: center center;
    cursor: pointer;
    background: url('~@/assets/img/tp-header/icon-16-drop-down.svg') no-repeat;
    background-position: center center;
  }
  .header-top-down-btn-hover{
    background-image: url('~@/assets/img/tp-header/icon-16-drop-down-hover.svg');
  }
  .header-top-up{
     margin-top: 5px;
     background: url('~@/assets/img/tp-header/icon-16-up.svg') no-repeat;
     background-position: center center;
  }
  .header-top-btn{
    width: 24px;
    height: 24px;
    background-position: center center;
    cursor: pointer;
  }
  .header-top-btn.is-active:hover{
    background-color: #dadce1;
    border-radius: 4px;
  }

  .is-active{
    background-color: #dadce1;
    border-radius: 4px;
  }

  .header-top-user-info{
    display: flex;

    .avatar{
      margin-right: 8px;
      cursor: pointer;
    }
    >div:last-child{
      margin-left: 8px;
    }
    // flex-direction: column;
  }
  .headr-top-add{
    background-color: #e9eaed !important;
    color: #4066d4 !important;
    border-color: transparent !important;
  }
  .header-top-user-name{
    max-width: 196px;
    height: 26px;
    line-height: 26px;
    // display: flex;
    // align-items: center;
    cursor: pointer;
    color: #4c556c;
    font-weight: 600;
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .header-user-name{
    color: #4066d4;
  }
  .header-user-box{
    padding: 16px;
    .header-user-info{
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f2f5;
      margin-bottom: 12px;
    }
    .header-user--info-list{
      width: 198px;
      margin-left: 6px;
      flex-direction: column;
      >p{
        /deep/ span{
          font-weight: 500;
          font-size: 12px;
          color: #7f8596;
          line-height: 17px;
        }
      }
      >p:first-child{
        /deep/ span{
          font-weight: bold;
          font-size: 14px;
          color: #222632;
          line-height: 22px;
          height: 22px;
          display: inline-block;
        }
      }
    }
    .header-user-opt-status{
      justify-content: space-between;
      position: relative;

      cursor: default!important;;
      &:hover{
        background: #fff!important;
      }
      >div{
        position: absolute;
        right:0;
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        color: #7F8596;
        .green{
          color: #069A49;
        }
      }
    }
    .header-user-opt{
      height: 36px;
      line-height: 36px;
      border-radius: 4px;
      padding-left: 8px;
      font-weight: 600;
      font-size: 12px;
      color: #000;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      ::v-deep .svg-icon{
          height: 24px;
          width: 24px;
          margin-right: 6px;
        }
      &:last-child{
        margin-top: 2px;
      }
      &:hover{
        background: #f4f5f9;
      }
    }
  }
  .dialer-pad-btn.svg-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .advertising-space-container {
    .commodities-container {
      height: 44px;
      .jump-subscribe {
        flex-shrink: 0;
        height: 26px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        border-radius: 4px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        text-transform: uppercase;
        color: #4066D4;
        cursor: pointer;
      }
      .limited-time-offer-container {
        height: 100%;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, #323A53 0%, #262F4B 32.7%, #0D1839 100%);
        overflow-x: hidden;
        .description {
          flex-shrink: 0;
          position: relative;
          margin-right: 12px;
          padding-right: 13px;
          display: flex;
          align-items: center;
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          color: #02E0DD;
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 14px;
            transform: translateY(-50%);
            background-color: rgba(255, 255, 255, 0.13);
          }
          .sales-icon {
            flex-shrink: 0;
            font-size: 16px;
          }
          .text {
            margin: 0 4px;
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 13px;
            line-height: 16px;
            background: linear-gradient(180deg, #21FFE6 0%, #00D5E2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
        }
        .first-month {
          flex-shrink: 0;
          padding-right: 24px;
          display: flex;
          align-items: center;
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          line-height: 22px;
          color: #FFFFFF;
          .text {
            margin: 0 6px;
            height: 26px;
            padding: 0 7px;
            display: flex;
            align-items: center;
            background: rgba(255, 255, 255, 0.14);
            border-radius: 5px;
            i {
              font-family: 'Open Sans';
              font-style: normal;
              font-weight: 700;
              font-size: 13px;
              line-height: 16px;
              background: linear-gradient(180deg, #21FFE6 0%, #00D5E2 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
            }
          }
        }
      }
      .limited-time-offer-expires-container, .trial-end-container {
        height: 100%;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, #323A53 0%, #262F4B 32.7%, #0D1839 100%);
        overflow-x: hidden;
        .text {
          padding-right: 24px;
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          line-height: 22px;
          color: #FFFFFF;
        }
      }
    }
  }
</style>

<style lang="scss">
   .header-top-pop.el-popper{
      border-radius: 6px;
      box-shadow: 0 1px 5px 0 rgba(0, 5, 57, 0.2);
      border: solid 1px #e1e3e9;
      margin-top: 4px !important;
      padding: 0 !important;
      // padding-top: 4px !important;
      min-width: auto !important;

      .header-top-add{
        width: 100%;
        padding: 8px;
        .svg-icon{
          height: 20px;
          width: 20px;
          margin-right: 6px;
        }
        div {
          cursor: pointer;
          user-select: none;
          margin-top: 2px;
          font-family: OpenSans-Semibold;
          font-size: 12px;
          line-height: 22px;
          width: 100%;
          color: #000;
          height: 36px;
          line-height: 36px;
          padding-left: 8px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          &:hover{
            background: #f4f5f9;
          }

          &:first-child{
            margin-top: 0;
          }
        }
      }

      .popper__arrow{
        // display: none !important;
        visibility: hidden;
      }

      .header-top-help{
        background: rgba(76, 85, 108, 0.95);
        color: #fff;
        font-weight: 500;
        font-size: 12px;
        line-height: normal;
        padding: 12px 10px;
        letter-spacing: normal;
        border-radius: 4px;
      }
   }
   .header-top-pop-help{
      font-size: 0;
      border: 0 none !important;
      transform: translateY(6px);
      .popper__arrow{
        display: block !important;
        visibility: visible !important;

        &::after{
          top: 0 !important;
          border-bottom-color: rgba(76, 85, 108, 0.95) !important;
        }
      }
   }
   .header-top-profile{
     transform: translateY(5px);
   }
   .header-top-user{
     padding: 16px;
     transform: translateX(-22px);
   }
  .header-dialog-fill{
    position: relative;

    &::before{
      content: '';
      position: absolute;
      top: -4px;
      left: 0;
      width: 100%;
      height: 4px;
      background: #fff;
      opacity: 0;
    }
  }
  .header-top-pop-transform{
    transform: translateX(calc(-50% + 12px));
  }
  .header-top-pop-transform-y{
    transform: translate(calc(-18% - 2px), -0px);
  }
  .header-top-add-font {
    height: 24px !important;
    line-height: 22px !important;
    background: transparent !important;
    border-color: transparent !important;
    .svg-icon{
      vertical-align: -0.17em !important;
    }
    &.common-button span{
      font-weight: 600 !important;
      font-size: 12px;
      vertical-align: 0.5px;
    }
  }

  .header-login{
    display: flex;
    align-items: center;
    > .common-button{
      height: 26px;
      line-height: 26px;
      span{
        font-family: 'Open Sans' !important;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
      }
    }
    > span{
      margin-right: 12px;
      cursor: pointer;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      color: #4C556C;
    }
  }
</style>
